import MobileFilterBar from './MobileFilterBar.jsx';

export default MobileFilterBar;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/SearchContent/MobileFilterBar/index.js